import { render, staticRenderFns } from "./BaseCascader.vue?vue&type=template&id=397c06ec&"
import script from "./BaseCascader.vue?vue&type=script&lang=js&"
export * from "./BaseCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports